import BandLifestyleFa from './BandLifestyle-fa.json';
import BandLifestyleEn from './BandLifestyle-en.json';
import BandLifestyleAr from './BandLifestyle-ar.json';
import BandLifestyleTr from './BandLifestyle-tr.json';

import RingLifestyleFa from './RingLifestyle-fa.json';
import RingLifestyleEn from './RingLifestyle-en.json';
import RingLifestyleAr from './RingLifestyle-ar.json';
import RingLifestyleTr from './RingLifestyle-tr.json';

import TrackerLifestyleFa from './TrackerLifestyle-fa.json';
import TrackerLifestyleEn from './TrackerLifestyle-en.json';
import TrackerLifestyleAr from './TrackerLifestyle-ar.json';
import TrackerLifestyleTr from './TrackerLifestyle-tr.json';

import WatchLifestyleFa from './WatchLifestyle-fa.json';
import WatchLifestyleEn from './WatchLifestyle-en.json';
import WatchLifestyleAr from './WatchLifestyle-ar.json';
import WatchLifestyleTr from './WatchLifestyle-tr.json';

export const lifestyleLocales = {
  fa: {
    BandLifestyle: BandLifestyleFa,
    RingLifestyle: RingLifestyleFa,
    TrackerLifestyle: TrackerLifestyleFa,
    WatchLifestyle: WatchLifestyleFa,
  },
  en: {
    BandLifestyle: BandLifestyleEn,
    RingLifestyle: RingLifestyleEn,
    TrackerLifestyle: TrackerLifestyleEn,
    WatchLifestyle: WatchLifestyleEn,
  },
  ar: {
    BandLifestyle: BandLifestyleAr,
    RingLifestyle: RingLifestyleAr,
    TrackerLifestyle: TrackerLifestyleAr,
    WatchLifestyle: WatchLifestyleAr,
  },
  tr: {
    BandLifestyle: BandLifestyleTr,
    RingLifestyle: RingLifestyleTr,
    TrackerLifestyle: TrackerLifestyleTr,
    WatchLifestyle: WatchLifestyleTr,
  },
};